<template>
  <div style="width:100%">
    <el-select
      v-model="content"
      ref="sselector"
      @focus
      :filterable="filterable"
      :clearable="clearable"
      :multiple="multiple"
      :remote="endPoint!==null"
      :placeholder="placeholder"
      :remote-method="remoteMethod"
      :loading="loading"
      @change="refocus()"
      automatic-dropdown
    >
      <el-option
        v-for="item in derivedOptionsRepo"
        :key="item[valueProp]"
        :label="item[labelProp]"
        :value="item[valueProp]"
      ></el-option>
    </el-select>
    <template v-if="allowAdd">
      <el-button @click="newOption=null,dialogVisible = true" type="text">
        <i class="material-icons">add_box</i>
      </el-button>
      <el-dialog title="Νέα επιλογή" :visible.sync="dialogVisible" width="30%" append-to-body>
        <el-input v-model="newOption"></el-input>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">Ακυρο</el-button>
          <el-button type="primary" @click="dialogVisible = false;addTheOption()">Προσθεσε</el-button>
        </span>
      </el-dialog>
    </template>
  </div>
</template>

<script>
import mdl from "~/mixins/mdl";
import { async } from "q";
export default {
  name: "s-tag-select",
  props: {
    placeholder: { type: String, default: "..." },
    endPoint: { type: Function, default: null },
    allowAdd: { type: Boolean, default: true },
    optionsRepo: { default: null },
    focusthis: { default: false },
    filterable: { default: false },
    clearable: { default: false },
    multiple: { default: false },
    // ref: { default: null },
    options: { default: null },
    value: { default: null },
    labelProp: { default: "label" },
    optionsDeilimeter: { type: String, default: "," },
    valueProp: { default: "value" }
  },
  data() {
    return {
      newOption: null,
      dialogVisible: false,
      content: null,
      loading: true,
      derivedOptionsRepo: null
    };
  },
  watch: {
    value: {
      handler(val, oldval) {
        if (val != oldval && val != this.content) {
          this.addTheOption(val, true);
        }
      },
      immediate: true
    },
    content: function(val, oldval) {
      if (oldval && (!val || !val.length)) {
        this.$emit("input", null);
        this.$emit("change", null);
        return;
      }
      if (val == oldval) return;
      if (val + "" == this.value + "") return;
      if (this.value && !oldval) return;

      // if (val != oldval) {
      if (
        this.optionsDeilimeter &&
        this.optionsDeilimeter != "" &&
        Array.isArray(val)
      ) {
        this.$emit("input", val.join(this.optionsDeilimeter));
        this.$emit("change", val.join(this.optionsDeilimeter));
      } else {
        this.$emit("input", val);
        this.$emit("change", val);
      }
      // } //{val:val,oldval:oldval})
    }
  },
  // computed: {
  //   selectOptions() {
  //     if (this.optionsRepo) return THEDC.repoDB[this.optionsRepo];
  //     else return this.options;
  //   }
  // },
  methods: {
    addTheOption(addOption, clear) {
      _log_("add checkOPT.", addOption);
      if (!addOption) return;
      const vm = this;
      addOption = addOption ? addOption : this.newOption;
      const posibleOptions = addOption.split(this.optionsDeilimeter);
      if (!this.derivedOptionsRepo) this.derivedOptionsRepo = [];

      posibleOptions.forEach(element => {
        var newValue = {};
        newValue[this.valueProp] = element;
        if (!this.findInArray(this.derivedOptionsRepo, newValue)) {
          newValue[this.labelProp] = element;
          vm.derivedOptionsRepo.push(newValue);
        }
      });

      _log_("add check.", this.derivedOptionsRepo);

      if (this.multiple !== null && this.multiple !== false) {
        if (!this.content || clear) this.content = [];
        posibleOptions.forEach(element => {
          vm.content.push(element);
        });
      } else this.content = addOption;
    },

    async remoteMethod(query) {
      if (!this.endPoint) return;
      if (
        query !== "" ||
        !this.derivedOptionsRepo ||
        this.derivedOptionsRepo.length < 2
      ) {
        // _log_("vhann....", query);
        this.loading = true;
        this.derivedOptionsRepo = await this.endPoint(query);
        this.loading = false;
      } else {
        this.derivedOptionsRepo = [];
      }
    },
    refocus() {
      var vm = this;

      let elel = this.$el; // vm.$refs['sselector']
      // if (elel) elel[0].focus()
      _log_("change sel.", elel);
      //  elel.focus();
      let inputs = elel.getElementsByTagName("input");
      // let elel = vm.$refs['col_input' + rowScope.column.property]
      // // if (elel) elel[0].focus()
      // _log_('is ins..F.' + colIndex, elel[0])
      inputs[0].focus();
    }
  },
  mounted: async function() {
    var vm = this;
    _log_("mount check.", this.value);
    // this.remoteMethod();
    // this.content = this.value;
    if (this.options) {
      this.derivedOptionsRepo = [];
      this.options.forEach(element => {
        if (_.isString(element))
          this.derivedOptionsRepo.push({ label: element, value: element });
        else this.derivedOptionsRepo.push(element);
      });
    } else this.derivedOptionsRepo = this.optionsRepo;
    var qoption = {};
    // if (this.value) {
    //   this.addTheOption(this.value)
    // }
    if (this.focusthis) {
      Vue.nextTick(function() {
        let elel = vm.$refs["sselector"];
        // if (elel) elel[0].focus()
        // _log_("is insCCC..F.", elel);
        elel.focus();
        let inputs = elel.$el.getElementsByTagName("input");
        // let elel = vm.$refs['col_input' + rowScope.column.property]
        // // if (elel) elel[0].focus()
        // _log_('is ins..F.' + colIndex, elel[0])
        inputs[0].focus();
      });
    }
    this.loading = false;
  }
  // mounted: async function() {
  //   var vm = this;
  //   _log_("mount check.", this.value);
  //   if (this.value) {
  //     if (this.multiple !== null && this.multiple !== false) {
  //       if (!_.isArray(this.value)) {
  //         if (this.value.indexOf(this.optionsDeilimeter) >= 0)
  //           this.content = this.value.split(this.optionsDeilimeter);
  //         else this.content = [this.value];
  //       } else this.content = this.value;
  //     } else this.content = this.value;
  //   }
  //   // this.content = this.value;
  //   if (this.options) {
  //     this.derivedOptionsRepo = [];
  //     this.options.forEach(element => {
  //       if (_.isString(element))
  //         this.derivedOptionsRepo.push({ label: element, value: element });
  //       else this.derivedOptionsRepo.push(element);
  //     });
  //   } else this.derivedOptionsRepo = this.optionsRepo;
  //   var qoption = {};
  //   if (this.content) {
  //     qoption[this.valueProp] = this.content;

  //     if (!this.derivedOptionsRepo) this.derivedOptionsRepo = [];
  //     if (this.lablelProp != this.valueProp && this.optionsPoint != null) {
  //       this.derivedOptionsRepo = await this.optiosPoint(this.content);
  //     } else if (this.lablelProp != this.valueProp && this.endPoint != null) {
  //       this.derivedOptionsRepo = await this.endPoint(this.content);
  //     } else if (!this.findInArray(this.derivedOptionsRepo, qoption)) {
  //       var optel = {};
  //       optel[this.valueProp] = this.content;
  //       optel[this.lablelProp] = this.content;
  //       this.derivedOptionsRepo.push(optel);
  //     }
  //   }
  //   if (this.focusthis) {
  //     Vue.nextTick(function() {
  //       let elel = vm.$refs["sselector"];
  //       // if (elel) elel[0].focus()
  //       // _log_("is insCCC..F.", elel);
  //       elel.focus();
  //       let inputs = elel.$el.getElementsByTagName("input");
  //       // let elel = vm.$refs['col_input' + rowScope.column.property]
  //       // // if (elel) elel[0].focus()
  //       // _log_('is ins..F.' + colIndex, elel[0])
  //       inputs[0].focus();
  //     });
  //   }
  //   this.loading = false;
  // }
};
</script>

<style  >
.dark .el-select__input {
  color: whitesmoke;
}
</style>
